module.exports = __webpack_public_path__ + "img/star.d2564908.png";